import { useEffect, useState } from 'react';
import axios from '../lib/axios';
import { endpoints } from '../constants/endpoints';
import { useUserStore } from '../store/userStore';
import { User } from '../types/auth';

export function useLoggedInUser(): { user: User | null; isChecking: boolean } {
  const { user, setUser } = useUserStore();
  const [isChecking, setIsChecking] = useState(user === null);

  useEffect(() => {
    if (user) return;

    const fetchLoggedInUser = async () => {
      try {
        const loggedInUser: User = await axios.get(endpoints.auth.me);
        setUser(loggedInUser);
      } catch {
        setUser(null);
      } finally {
        setIsChecking(false);
      }
    };

    fetchLoggedInUser();
  }, [user, setUser]);

  return { user, isChecking };
}
